import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext"; 
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import SRRequests from "./SRRequests";
import SRReturns from "./SRReturns";
import SRReceiveStock from "./SRReceiveStock";
import SRManageStock from "./SRManageStock";
import SRManageVendor from "./SRManageVendor";
import SRManagePOs from "./SRManagePOs";
import SRReports from "./SRReports";
import { GlobalTabCollection, StyledTab } from "../../pages/styles";
import { Roles } from "../../constants/roles";
import AuthGate from "../../routing/components/AuthGate";
import { usePreferences } from "../../context/PreferencesContext";
import SiteApi from "../../api/Admin/Site";

const StockroomManagement = () => {
  const [tabValue, setTabValue] = useState(0);
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const {
    userPreferences      
  } = usePreferences();
    
  const readOnlyHomeSite = (
    <Typography fontSize={18} marginTop={1}>
      <strong>Home Site:</strong> {userPreferences?.homeSiteName ?? "N/A"}
    </Typography>
  );

  useEffect(() => {  
    SiteApi.getAllActive().then((res) => {
            setSites(
              res
                .filter((d) => !d.isExternalSite && (d.siteName === "Houston Campus" || d.siteName === "Clinton Technical Center"))
                .sort((a, b) => a.siteName?.localeCompare(b?.siteName ?? "")),
            );
          }); 
    if(!selectedSite && userPreferences?.homeSiteName)
      setSelectedSite(userPreferences?.homeSiteName)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  const { hasAnyRole } = useAuth();
  const canEdit = hasAnyRole([Roles.StockroomWorker, Roles.Developer]);

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <SRRequests canEdit={canEdit} selectedSite={selectedSite}/>
      }
      case 1: {
        return <SRReturns canEdit={canEdit} selectedSite={selectedSite}/>
      }
      case 2: {
        return <SRReceiveStock canEdit={canEdit} selectedSite={selectedSite}/>
      }
      case 3: {
        return <SRManageStock canEdit={canEdit} selectedSite={selectedSite}/>
      }
      case 4: {
        return <SRManageVendor canEdit={canEdit}/>
      }
      case 5: {
        return <SRManagePOs canEdit={canEdit} selectedSite={selectedSite}/>
      }
      case 6: {
        return <SRReports canEdit={canEdit} selectedSite={selectedSite}/>
      }
      default: {
        alert(tabValue);
      }
    }
  };
  return (
    <div>
        <Typography component="h2" fontSize={30} marginBottom={2}>
          Viewing Stockroom For
        </Typography>
        <Box sx={{ bgcolor: "#fff"}} display="flex" flexDirection="column" gap={6}>
          <Box
            display="flex"
            alignItems="flex-start"
            gap={2}
            flexDirection="column"
            alignContent="center"
          >
            <AuthGate fallback={readOnlyHomeSite}>
              <Box display="flex" gap={5}>
                <Autocomplete
                  size="small"
                  style={{ width: "30rem" }}
                  id="site-select"
                  disablePortal
                  noOptionsText={"Loading Sites..."}
                  options={sites}
                  isOptionEqualToValue={(option, value) => option.siteName === value.siteName}
                  getOptionLabel={(s) => s.isExternalSite ? `EXT - ${s.siteName}` : s.siteName}
                  onChange={(e, value) =>
                    {setSelectedSite(value?.siteName || userPreferences?.homeSiteName || "")}
                  }
                  autoHighlight
                  autoSelect
                  value={
                    sites?.find(p => p.siteName === selectedSite) ||
                    sites?.find(p => p.siteName === userPreferences?.homeSiteName) ||
                    null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Site"
                      InputProps={{ ...params.InputProps }}
                    />
                  )}
                />
              </Box>
            </AuthGate>
          </Box>          
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Requests' />
            <StyledTab label='Returns' />
            <StyledTab label='Receive Stock' />
            <StyledTab label='Manage Stock' />
            <StyledTab label='Manage Vendor' />
            <StyledTab label='Manage POs' />
            <StyledTab label='Reports' />
          </GlobalTabCollection>
        </Box>
        <Box sx={{ p: 3 }} />
        {renderSearchTab()}
      </div>
  );
};

export default StockroomManagement;